<template>
  <div class="cart-complete-page pt-4">
    <PageContainer v-if="data">
      <div class="delivery-date">
        最短お届け予定日：
        {{ $d(data.earliest_date, 'date') }}
        ({{ $d(data.earliest_date, 'day') }})
      </div>
      <div class="order-number">ご購入完了【ご購入番号：{{ data.order.id }}】</div>
      <div class="body">
        ご購入ありがとうございました<br>
        ただいま、ご購入の確認メールをお送りさせていただきました<br>
        <br>
        確認メールが届かない場合、以下理由が考えられます<br>
        ・ドメイン指定等、受信制限設定がされている。<br>
        ・ごみ箱や迷惑メール等、受信フォルダ以外の箇所に届いてしまっている。<br>
        ・通信環境による遅延。<br>
        ご確認いただきました上で、CAVIN公式LINEにてお問い合わせくださいませ。<br>
        今後ともご愛顧承りますようよろしくお願い申し上げます。<br>
      </div>
      <div>
        <ListItem label="連絡先"><a :href="officialLineUrl">CAVIN公式LINE</a></ListItem>
      </div>
      <Button class="button" to="/shop/products">TOPに戻る</Button>
    </PageContainer>
  </div>
</template>

<script>
import PageContainer from "@/components/shop/PageContainer.vue";
import Button from "@/components/shop/Button.vue";
import ListItem from "@/components/shop/ListItem.vue";

export default {
  components: {
    PageContainer,
    Button,
    ListItem
  },

  data() {
    return {
      data: null
    };
  },

  async mounted() {
    const { result } = await this.$api.get("/orders/complete");
    this.data = result;

    this.$datalayer.sendData(result.order);

    this.$store.dispatch("orders/getOrdersDraft");
    this.$store.dispatch("conversations/getConversations");
  },
  computed: {
    officialLineUrl() {
      return process.env.VUE_APP_X_OFFICIAL_LINE_URL;
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-complete-page {
  background-color: #fff;
}

.delivery-date {
  padding: 12px 24px;
  color: #FFF;
  font-size: 24px;
  font-weight: bold;
  background-color: #8ACEFF;
}

.order-number {
  margin: 24px 0 16px;
  font-size: 24px;
  font-weight: bold;
  color: #555;
}

.body {
  margin-bottom: 16px;
  font-size: 16px;
  color: #777;
}

.button {
  margin: 24px auto 0;
}
</style>
